import { isEmpty } from 'lodash';
import { useRef, useState } from 'react';
import { tAgendaManagementModalHook } from '../Agenda.types';
import { useAgendaTemplatesContext } from './agendaTemplateView.hook';

export default function useAgendaTemplateManagementModal(): tAgendaManagementModalHook {
  const { currentTemplateFields } = useAgendaTemplatesContext();

  const templateManagementModalRef = useRef<HTMLFormElement>(null);
  const [noSelectionError, setNoSelectionError] = useState(false);

  function submitTemplateForm() {
    if (isEmpty(currentTemplateFields)) {
      setNoSelectionError(true);
      return;
    }

    templateManagementModalRef.current?.requestSubmit();
  }

  return {
    templateManagementModalRef,
    submitTemplateForm,
    noSelectionError,
  };
}
